import { SET_SYSTEM_NOTIFICATION_MODAL_VISIBLE } from '../actionConstants/systemConstants';

export const setSystemNotificationModalVisible = ({ notificationType, visible }) => ({
  type: SET_SYSTEM_NOTIFICATION_MODAL_VISIBLE,
  payload: { notificationType, visible },
});
